import { ReactNode } from 'react';

import { Wrapper } from './Card.styles';

interface CardProps {
  border?: boolean;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  shadow?: boolean;
  statusColor?:
    | 'black'
    | 'blue'
    | 'green'
    | 'lightGray'
    | 'lightGreen'
    | 'mediumGray'
    | 'orange'
    | 'purple'
    | 'red'
    | 'yellow';
  statusSize?: 'medium' | 'small';
  tooltip?: string;
}

const Card = ({
  border,
  children,
  className,
  disabled = false,
  onClick,
  shadow,
  statusColor,
  statusSize = 'small',
  tooltip,
}: CardProps): JSX.Element => (
  <Wrapper
    border={border}
    className={className}
    data-tip={tooltip}
    disabled={disabled}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(!disabled && { onClick })}
    shadow={shadow}
    statusColor={statusColor}
    statusSize={statusSize}
  >
    {children}
  </Wrapper>
);

export default Card;
